export default {
  direct: 'Directe',
  stops: 'escales',
  stop: 'escale',
}
